import React from "react";
import useButton from "./useButton";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";
interface IButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  title: string;
  isDisabled: boolean;
  className?: string;
  containerClassName?: string;
}

const Button: React.FC<IButtonProps> = (props: IButtonProps) => {
  const { title, onClick, isDisabled, className, containerClassName } = props;
  const { className: buttonClassName, containerClass } = useButton(props);

  return (
    <div className={twMerge(clsx(containerClass, containerClassName))}>
      <button disabled={isDisabled} onClick={onClick} className={twMerge(clsx(buttonClassName, className))}>
        {title}
      </button>
    </div>
  );
};

export default Button;
